import React, {
  useCallback,
  useEffect,
  useRef,
} from "react";
import {
  StyledIconButton,
  StyledToggleButton,
  PrimaryButton,
  SecondaryButton,
  StyledToggleButtonGroup,
} from "../../../../components/StyledComponents/Buttons/AuradineButtons";
import { StyledFormControl } from "../../../../components/StyledComponents/Inputs/Inputs.js";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterList from "@mui/icons-material/FilterList";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import {
  StyledDialog,
  StyledDialogTitle,
} from "../../../../components/StyledComponents/Dialog/Dialog";
import {
  H6HeadlineSmall,
  H8TitleMedium,
  LabelLarge,
} from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";
import {
  DialogContent,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  ToggleButton,
  Autocomplete,
  DialogActions,
  CircularProgress,
  Menu,
  Badge,
  styled,
  IconButton,
  Tabs,
  Tab,
  ToggleButtonGroup,
  colors,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PlaceHolderButton from "../../../../components/PlaceHolderButton/PlaceHolderButton";
import {
  StyledSelect,
  StyledTextField,
} from "../../../../components/StyledComponents/Inputs/Inputs.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useListCBSNs } from "../../../queries/useListCBSNS.ts";
import { debounce } from "lodash";
import { set } from "date-fns";
import { useGetTagsList } from "../../../../api/queries/useGetTagsList.ts";
import { useListSerialNumbers } from "../../../queries/useListSerialNumbers.ts";
import { useListSoftwareVersions } from "../../../queries/useListSoftwareVersions.ts";
import { useListMacs } from "../../../queries/useListMacs.ts";
import { usePostOrg } from "../../../../api/queries/usePostOrg.ts";
import useMinerPageContext from "../../../context/useMinerPageContext.js";
import { useQuery } from "@tanstack/react-query";
import SavedLists from "./SavedLists/SavedLists.js";
import { GetFilterListNames } from "../../../../api/api.js";

const CustomBadge = styled(Badge)(({ colors }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: colors?.primary?.main,  
    color:  colors?.primary?.contrastText,
    fontSize: "0.75rem", // Optional: Adjust font size
    padding: "0.25rem", // Optional: Adjust padding
  },
}));

const FilterModal = (props) => {
  const { open, setOpenFilter } = props;
  const { currentTheme } = useTheme();
  const [authToken, setAuthToken] = useState("");
  const [inputModelValue, setInputModelValue] =
    useState("");
  const [statusValue, setStatusValue] = useState("");

  const [cbsnInputValue, setCbsnInputValue] = useState("");
  const [dcbsnInputValue, setDCbsnInputValue] =
    useState("");
  const [tagsValue, setTagsValue] = useState("");
  const [dtagsValue, setDTagsValue] = useState("");

  const [serialNumbersValue, setSerialNumbersValue] =
    useState("");
  const [dserialNumbersValue, setDSerialNumbersValue] =
    useState("");
  const [macsValue, setMacsValue] = useState("");
  const [dmacsValue, setDMacsValue] = useState("");
  const [dversion, setDVersion] = useState("");
  const [versionValue, setVersionValue] = useState("");

  const CBSNListBoxRef = useRef();
  const TagsListBoxRef = useRef();
  const SerialNumbersListBoxRef = useRef();
  const MacsListBoxRef = useRef();
  const SoftwareVersionsListBoxRef = useRef();
  const fieldRefs = useRef({});
  const { setGroupFilters } = useMinerPageContext();
  const [selectedTab, setSelectedTab] = useState(0);
  const [chassisMode, setChassisMode] =
    useState("individual");
  const [cbsnMode, setCbsnMode] = useState("individual");
  const [macMode, setMacMode] = useState("individual");

  const handleDebounceCBSNSearch = useCallback(
    debounce((value) => {
      setDCbsnInputValue(value);
      // Call the API or perform the search with the debounced value
    }, 500),
    []
  ); // Adjust the debounce delay as needed

  const handleCBSNSearch = (data) => {
    setCbsnInputValue(data);
    handleDebounceCBSNSearch(data);
  };

  const handleDebounceTagsSearch = useCallback(
    debounce((value) => {
      setDTagsValue(value);
    }, 500),
    []
  );

  const handleTagsSearch = (data) => {
    setTagsValue(data);
    handleDebounceTagsSearch(data);
  };

  const handleDebounceSerialNumbersSearch = useCallback(
    debounce((value) => {
      setDSerialNumbersValue(value);
    }, 500),
    []
  );

  const handleMacsSearch = (data) => {
    setMacsValue(data);
    handleDebounceMacsSearch(data);
  };

  const handleDebounceMacsSearch = useCallback(
    debounce((value) => {
      setDMacsValue(value);
    }, 500),
    []
  );

  const handleSerialNumbersSearch = (data) => {
    setSerialNumbersValue(data);
    handleDebounceSerialNumbersSearch(data);
  };

  const handleDebounceSoftwareVersionsSearch = useCallback(
    debounce((value) => {
      setDVersion(value);
    }, 500),
    []
  );

  const handleSoftwareVersionsSearch = (data) => {
    setVersionValue(data);
    handleDebounceSoftwareVersionsSearch(data);
  };

  const {
    control,
    handleSubmit,
    watch,
    setFocus,
    setValue,
    reset,
    trigger,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      minimumChipTemperature: null,
      maximumChipTemperature: null,
      minimumHashRate: null,
      maximumHashRate: null,
      fromIP: null,
      toIP: null,
      model: [],
      mode: [],
      tuningConfiguration: null,
      minUpTime: null,
      maxUpTime: null,
      minPower: null,
      maxPower: null,
      minimumPowerEfficiency: null,
      maximumPowerEfficiency: null,
      tags: [],
      status: [],
      chassis: [],
      chassis1: "",
      CBSN: [],
      CBSN1: "",
      mac: [],
      mac1: "",
      chassisListName: "",
      CBSNListName: "",
      macListName: "",
      version: [],
      CSTag: "",
    },
  });
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();

  const {
    data: filterNames,
    refetch: refetchFilterNames,
    isLoading: areFilterNamesLoading,
  } = useQuery({
    queryKey: ["filterListNames", open],
    queryFn: async () => {
      if (!isAuthenticated) return null;
      const token = await getAccessTokenSilently();
      const response = await GetFilterListNames(token);
      return response.msg;
    },
    enabled: open,
    staleTime: 0,
  });

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000);

    // Clean up the interval on unmount
    return () => clearInterval(interval);
  }, [isAuthenticated, getAccessTokenSilently]);

  //pagination call for fetching CBSNs
  const {
    data,
    fetchNextPage: fetchCBSNNextPage,
    hasNextPage: hasCBSNNextPage,
    isFetchingNextPage: isCBSNFetchingNextPage,
    status,
    isFetched: isCBSNFetched,
    isLoading: isCBSNLoading,
  } = useListCBSNs({
    open: open,
    authToken,
    cbsn: dcbsnInputValue,
  });

  //pagination call for fetching tags
  const {
    data: tagsData,
    fetchNextPage: fetchTagsNextPage,
    hasNextPage: tagsHasNextPage,
    isFetchingNextPage: isFetchingTagsNextPage,
    refetch: tagsDataRefetch,
    isFetched: isTagsDataFetched,
    isLoading: isTagsDataLoading,
  } = useGetTagsList({
    authToken,
    tagName: dtagsValue,
  });

  //pagination call for fetching serial numbers
  const {
    data: serialNumbersData,
    fetchNextPage: fetchSerialNumbersNextPage,
    hasNextPage: serialNumbersHasNextPage,
    isFetchingNextPage: isFetchingSerialNumbersNextPage,
    refetch: serialNumbersDataRefetch,
    isFetched: isSerialNumbersFetched,
    isLoading: isSerialNumbersLoading,
  } = useListSerialNumbers({
    open: open,
    authToken,
    chassisSerialNo: dserialNumbersValue,
  });

  //pagination call for fetching macs
  const {
    data: macsData,
    fetchNextPage: fetchMacsNextPage,
    hasNextPage: macsHasNextPage,
    isFetchingNextPage: isFetchingMacsNextPage,
    refetch: macsDataRefetch,
    isFetched: isMacsFetched,
    isLoading: isMacsLoading,
  } = useListMacs({
    open: open,
    authToken,
    mac: dmacsValue,
  });

  //pagination call for fetching software versions
  const {
    data: softwareVersionsData,
    fetchNextPage: fetchSoftwareVersionsNextPage,
    hasNextPage: softwareVersionsHasNextPage,
    isFetchingNextPage: isFetchingSoftwareVersionsNextPage,
    refetch: softwareVersionsDataRefetch,
    isFetched: isSoftwareVersionsFetched,
    isLoading: isSoftwareVersionsLoading,
  } = useListSoftwareVersions({
    open: open,
    authToken,
    version: dversion,
  });

  const {
    data: auradineModelsData,
    refetch: auradineModelsRefetch,
    isLoading: isAuradineModelsLoading,
    isFetching: isAuradineModelsFetching,
    isFetched: isAuradineModelsFetched,
  } = usePostOrg({
    open: open,
    authToken,
    ...{
      projection: { auradineModels: 1 },
    },
  });

  //cbsn Data
  const CBSNs =
    data?.pages
      ?.flatMap((page) => (page?.msg ? page?.msg : []))
      .filter((x) => x) || [];

  //tags data
  const tags =
    tagsData?.pages
      ?.flatMap((page) => (page?.msg ? page?.msg : []))
      .map((tag) => (tag?.tag ? tag?.tag : ""))
      .filter((x) => x) || [];

  //serial numbers data
  const serialNumbers =
    (serialNumbersData &&
      serialNumbersData?.pages?.flatMap((page) =>
        page?.msg ? page?.msg : []
      )) ||
    [];

  //mac data
  const mac =
    (macsData &&
      macsData?.pages?.flatMap((page) =>
        page?.msg ? page?.msg : []
      )) ||
    [];

  //software versions data
  const softwareVersions =
    softwareVersionsData?.pages
      ?.flatMap((page) => (page?.msg ? page?.msg : []))
      .filter((x) => x) || [];
  const auradineModels =
    isAuradineModelsFetched &&
    Array.isArray(
      auradineModelsData?.result?.auradineModels
    ) &&
    auradineModelsData?.result?.auradineModels.length > 0
      ? auradineModelsData?.result?.auradineModels.filter(
          (model) => model !== null && model !== ""
        )
      : [];

  const handleCBSNScroll = (event) => {
    const listboxNode = event.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } =
      listboxNode;
    if (
      scrollHeight - scrollTop - clientHeight < 100 &&
      !isCBSNLoading
    ) {
      if (hasCBSNNextPage) {
        fetchCBSNNextPage();
      }
    }
  };

  const handleTagsScroll = (event) => {
    const listboxNode = event.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } =
      listboxNode;
    if (
      scrollHeight - scrollTop - clientHeight < 100 &&
      !isTagsDataLoading
    ) {
      if (tagsHasNextPage) {
        fetchTagsNextPage();
      }
    }
  };

  const handleMacsScroll = (event) => {
    const listboxNode = event.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } =
      listboxNode;
    if (
      scrollHeight - scrollTop - clientHeight < 100 &&
      !isMacsLoading
    ) {
      if (macsHasNextPage) {
        fetchMacsNextPage();
      }
    }
  };

  const handleSerialNumbersScroll = (event) => {
    const listboxNode = event.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } =
      listboxNode;
    if (
      scrollHeight - scrollTop - clientHeight < 100 &&
      !isSerialNumbersLoading
    ) {
      if (serialNumbersHasNextPage) {
        fetchSerialNumbersNextPage();
      }
    }
  };

  const handleSoftwareVersionsScroll = (event) => {
    const listboxNode = event.currentTarget;
    const { scrollTop, scrollHeight, clientHeight } =
      listboxNode;
    if (
      scrollHeight - scrollTop - clientHeight < 100 &&
      !isSoftwareVersionsLoading
    ) {
      if (softwareVersionsHasNextPage) {
        fetchSoftwareVersionsNextPage();
      }
    }
  };

  const minChipTemp = watch("minimumChipTemperature");
  const maxChipTemp = watch("maximumChipTemperature");
  const minHashRate = watch("minimumHashRate");
  const maxHashRate = watch("maximumHashRate");
  const minUpTime = watch("minUpTime");
  const maxUpTime = watch("maxUpTime");

  const fromIP = watch("fromIP");
  const toIP = watch("toIP");

  const minPwr = watch("minPower");
  const maxPwr = watch("maxPower");

  const minPwrEff = watch("minimumPowerEfficiency");
  const maxPwrEff = watch("maximumPowerEfficiency");

  const modeValue = watch("mode");
  const selectedTuningConfiguration = watch(
    "tuningConfiguration"
  );
  const selectedAutoCompleteOptions = watch("status");
  const selectedTags = watch("tags");
  const selectedModel = watch("model");
  const selectedChassisSerialNumber = watch("chassis");
  const selectedMacs = watch("mac");
  const selectedControlBoardSerialNumber = watch("CBSN");
  const selectedSoftwareVersion = watch("version");

  const filterManagement = filterNames || {};

  const chassisListNames =
    filterManagement["Chassis"] || [];
  const cbsnListNames = filterManagement["CBSN"] || [];
  const macListNames = filterManagement["MAC"] || [];

  // when filter modal opens, gets the filters from url params,
  // reset(filter) to fill in inputs in form, then updates groupFilters
  const getFiltersFromURL = () => {
    const params = new URLSearchParams(
      window.location.search
    );
    return {
      CBSN: params.getAll("CBSN") || [],
      CBSN1: params.get("CBSN1") || "",
      chassis: params.getAll("chassis") || [],
      chassis1: params.get("chassis1") || "",
      mac: params.getAll("mac") || [],
      mac1: params.get("mac1") || "",
      fromIP: params.get("fromIP") || "",
      maxPower: params.get("maxPower") || "",
      maxUpTime: params.get("maxUpTime") || "",
      maximumChipTemperature:
        params.get("maximumChipTemperature") || "",
      maximumHashRate: params.get("maximumHashRate") || "",
      maximumPowerEfficiency:
        params.get("maximumPowerEfficiency") || "",
      minPower: params.get("minPower") || "",
      minUpTime: params.get("minUpTime") || "",
      minimumChipTemperature:
        params.get("minimumChipTemperature") || "",
      minimumHashRate: params.get("minimumHashRate") || "",
      minimumPowerEfficiency:
        params.get("minimumPowerEfficiency") || "",
      mode: params.getAll("mode") || "",
      model: params.getAll("model") || "",
      status: params.getAll("status") || [],
      tags: params.getAll("tags") || [],
      toIP: params.get("toIP") || "",
      tuningConfiguration:
        params.get("tuningConfiguration") || "",
      chassisListName: params.get("chassisListName") || "",
      CBSNListName: params.get("CBSNListName") || "",
      macListName: params.get("macListName") || "",
      version: params.getAll("version") || [],
    };
  };

  useEffect(() => {
    if (open) {
      const filters = getFiltersFromURL();

      if (filters && filters?.CBSN1) {
        setCbsnInputValue(filters?.CBSN1);
      }
      if (filters && filters?.chassis1) {
        setSerialNumbersValue(filters?.chassis1);
      }
      if (filters && filters?.mac1) {
        setMacsValue(filters?.mac1);
      }
      if (filters?.chassisListName) {
        setChassisMode("saved");
      } else {
        setChassisMode("individual");
      }
      if (filters?.CBSNListName) {
        setCbsnMode("saved");
      } else {
        setCbsnMode("individual");
      }
      if (filters?.macListName) {
        setMacMode("saved");
      } else {
        setMacMode("individual");
      }
      reset(filters);
      // setGroupFilters(filters);
    }
  }, [open]);
  function ipToNumberNoBit(ip) {
    if (!ip || typeof ip !== "string") {
      return -1;
    }
    const parts = ip.split(".").map((part) => Number(part));
    if (
      parts.length !== 4 ||
      parts.some((p) => p < 0 || p > 255 || Number.isNaN(p))
    ) {
      return -1;
    }
    return (
      parts[0] * 256 ** 3 +
      parts[1] * 256 ** 2 +
      parts[2] * 256 +
      parts[3]
    );
  }

  // on click of apply button, updates filter in context and
  // clears then updates url params and applies new, updated filters through groupFilters
  const onSubmit = (data) => {
    const finalData =
      data && Object.keys(data).length > 0
        ? Object.fromEntries(
            Object.entries(data) // eslint-disable-next-line no-unused-vars
              .map(([key, value]) => {
                if (
                  [
                    "CBSN",
                    "chassis",
                    "mac",
                    "status",
                    "tags",
                    "version",
                    "model",
                    "mode",
                  ].includes(key)
                ) {
                  if (typeof value === "string") {
                    return [key, [value]];
                  }
                  if (Array.isArray(value)) {
                    return [key, value.map(String)];
                  }
                }
                return [key, value];
              })
              .filter(
                ([key, value]) =>
                  value !== null &&
                  value !== undefined &&
                  value !== "" &&
                  (!Array.isArray(value) ||
                    value.length > 0)
              )
          )
        : [];
    if (
      cbsnMode === "individual" &&
      cbsnInputValue &&
      (!finalData["CBSN"] || finalData["CBSN"].length === 0)
    ) {
      finalData["CBSN1"] = cbsnInputValue;
    } else {
      finalData["CBSN1"] = "";
    }
    if (
      chassisMode === "individual" &&
      serialNumbersValue &&
      (!finalData["chassis"] ||
        finalData["chassis"].length === 0)
    ) {
      finalData["chassis1"] = serialNumbersValue;
    } else {
      finalData["chassis1"] = "";
    }
    if (
      macMode === "individual" &&
      macsValue &&
      (!finalData["mac"] || finalData["mac"].length === 0)
    ) {
      finalData["mac1"] = macsValue;
    } else {
      finalData["mac1"] = "";
    }

    sessionStorage.setItem(
      "minerFilters",
      JSON.stringify(finalData)
    );

    const url = new URL(window.location.href);
    url.search = "";

    const siteGroup =
      JSON.parse(sessionStorage.getItem("siteGroup")) || {};
    const { siteName, dgname } = siteGroup;
    if (siteName)
      url.searchParams.set("siteName", siteName);
    if (dgname) url.searchParams.set("dgname", dgname);

    for (const key in finalData) {
      if (Array.isArray(finalData[key])) {
        finalData[key].forEach((value) =>
          url.searchParams.append(key, value)
        );
      } else {
        if (finalData[key] !== "") {
          url.searchParams.set(key, finalData[key]);
        }
      }
    }

    // update the URL without reloading the page
    window.history.replaceState({}, "", url);

    setGroupFilters(finalData);
    setOpenFilter(false);
  };

  const ClearFilters = () => {
    reset({
      minimumChipTemperature: "",
      maximumChipTemperature: "",
      minimumHashRate: "",
      maximumHashRate: "",
      fromIP: "",
      toIP: "",
      model: [],
      mode: [],
      tuningConfiguration: "",
      minUpTime: "",
      maxUpTime: "",
      minPower: "",
      maxPower: "",
      minimumPowerEfficiency: "",
      maximumPowerEfficiency: "",
      tags: [],
      status: [],
      chassis: [],
      mac: [],
      CBSN: [],
      chassisListName: "",
      macListName: "",
      CBSNListName: "",
      version: [],
      CSTag: "",
    });
    const url = new URL(window.location.href);
    const siteName = url.searchParams.get("siteName");
    const dgname = url.searchParams.get("dgname");

    url.search = "";
    if (siteName)
      url.searchParams.set("siteName", siteName);
    if (dgname) url.searchParams.set("dgname", dgname);

    window.history.replaceState({}, "", url);
    setCbsnInputValue("");
    setSerialNumbersValue("");
    setMacsValue("");
    setChassisMode("individual");
    setCbsnMode("individual");
    setMacMode("individual");
    setGroupFilters({});
    sessionStorage.setItem(
      "minerFilters",
      JSON.stringify({})
    );
  };

  const onError = (errors) => {
    // Get the first field with an error
    const firstErrorField = Object.keys(errors)[0];
    const fieldElement = fieldRefs.current[firstErrorField];

    if (fieldElement) {
      fieldElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      fieldElement.focus();
    }
  };

  const handleStatusAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = selectedAutoCompleteOptions.filter(
      (option) => option !== optionToDelete
    );
    setValue("status", newValue);
  };

  const handleModeAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = modeValue.filter(
      (option) => option !== optionToDelete
    );
    setValue("mode", newValue);
  };

  const handleTagsAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = selectedTags.filter(
      (option) => option !== optionToDelete
    );
    setValue("tags", newValue);
  };

  const handleChassisSerialNumberAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = selectedChassisSerialNumber.filter(
      (option) => option !== optionToDelete
    );
    setValue("chassis", newValue);
  };

  const handleMacsAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = selectedMacs.filter(
      (option) => option !== optionToDelete
    );
    setValue("mac", newValue);
  };

  const handleControlBoardSerialNumberAutoCompleteDeletion =
    (optionToDelete) => {
      const newValue =
        selectedControlBoardSerialNumber.filter(
          (option) => option !== optionToDelete
        );
      setValue("CBSN", newValue);
    };

  const handleSoftwareVersionAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = selectedSoftwareVersion.filter(
      (option) => option !== optionToDelete
    );
    setValue("version", newValue);
  };

  const handleModelAutoCompleteDeletion = (
    optionToDelete
  ) => {
    const newValue = watch("model").filter(
      (option) => option !== optionToDelete
    );
    setValue("model", newValue);
  };

  const statusOptions = [
    { label: "Connected", group: "Miner Status" },
    { label: "Disconnected", group: "Miner Status" },
    { label: "Onboarded", group: "Miner Status" },
    { label: "Standby Mode", group: "LED Status" },
    { label: "Normal", group: "LED Status" },
    { label: "Tuning", group: "LED Status" },
    {
      label: "Pool configuration invalid",
      group: "LED Status",
    },
    {
      label: "Control board faulty",
      group: "LED Status",
    },
    { label: "Fan malfunction", group: "LED Status" },
    { label: "PSU malfunction", group: "LED Status" },
    {
      label: "Hash board malfunction",
      group: "LED Status",
    },
    {
      label: "Hash rate lower than target",
      group: "LED Status",
    },
    { label: "Leak Detected", group: "LED Status" },
    {
      label: "Temperature too high",
      group: "LED Status",
    },
    { label: "Locate miner", group: "LED Status" },
  ];

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      disableScrollLock
      TransitionProps={{ timeout: 0 }}
      maxWidth={"lg"}
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          setOpenFilter(false);
          setSelectedTab(0);
        }
      }}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H6HeadlineSmall style={{ textAlign: "left" }}>
            Filters
          </H6HeadlineSmall>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setOpenFilter(false);
              setSelectedTab(0);
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) =>
            setSelectedTab(newValue)
          }
          variant="fullWidth"
          textColor="inherit"
          indicatorColor="primary"
          TabIndicatorProps={{
            children: (
              <span className="MuiTabs-indicatorSpan" />
            ),
          }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              color: colors.text.label,
              fontFamily: "Roboto",
              fontSize: "1rem",
              fontWeight: "500",
              lineHeight: "1.25rem",
            },
            "& .Mui-selected": {
              color: colors.primary.main, // Use theme primary color for selected tab
            },
            "& .MuiTabs-indicator": {
              display: "flex",
              justifyContent: "center",
              height: "4px",
              backgroundColor: "transparent",
            },
            "& .MuiTabs-indicatorSpan": {
              backgroundColor: colors.primary.main,
              borderTopLeftRadius: 100,
              width: "25%",
              borderTopRightRadius: 100,
            },
          }}
        >
          <Tab label="Filters" />
          <Tab label="Saved Lists" />
        </Tabs>
        {selectedTab === 0 && (
          <Box sx={{ paddingTop: "1rem" }}>
            <form
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={8}
                maxHeight={"60vh"}
                overflow={"auto"}
                sx={{
                  scrollbarWidth: "none",
                  overflowAnchor: "none",
                }}
              >
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className
                >
                  <H8TitleMedium>
                    Chip Temperature (°C)
                  </H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="minimumChipTemperature"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            value?.trim?.()
                          );
                          const maxVal = parseFloat(
                            watch(
                              "maximumChipTemperature"
                            )?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (minVal > maxVal) {
                              return "Min temperature must be less than or equal to max temperature";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "minimumChipTemperature"
                            ] = element)
                          }
                          variant="outlined"
                          label="Min Chip Temperature"
                          style={{ flex: 1 }}
                          type="number"
                          error={
                            errors.minimumChipTemperature
                              ? true
                              : false
                          }
                          helperText={
                            errors.minimumChipTemperature
                              ? errors
                                  .minimumChipTemperature
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (
                              !errors.maximumChipTemperature
                            ) {
                              trigger(
                                "minimumChipTemperature"
                              );
                            } else {
                              trigger([
                                "minimumChipTemperature",
                                "maximumChipTemperature",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumChipTemperature",
                              "maximumChipTemperature",
                            ]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="maximumChipTemperature"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const maxVal = parseFloat(
                            value?.trim?.()
                          );
                          const minVal = parseFloat(
                            watch(
                              "minimumChipTemperature"
                            )?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (maxVal < minVal) {
                              return "Max temperature must be greater than or equal to min temperature";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "maximumChipTemperature"
                            ] = element)
                          }
                          variant="outlined"
                          label="Max Chip Temperature"
                          style={{ flex: 1 }}
                          type="number"
                          error={
                            !!errors.maximumChipTemperature
                          }
                          helperText={
                            errors.maximumChipTemperature
                              ? errors
                                  .maximumChipTemperature
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (
                              !errors.minimumChipTemperature
                            ) {
                              trigger(
                                "maximumChipTemperature"
                              );
                            } else {
                              trigger([
                                "minimumChipTemperature",
                                "maximumChipTemperature",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumChipTemperature",
                              "maximumChipTemperature",
                            ]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="hashRateContainer"
                >
                  <H8TitleMedium>
                    Hash Rate (TH/s)
                  </H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="minimumHashRate"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const maxVal = parseFloat(
                            watch(
                              "maximumHashRate"
                            )?.trim?.()
                          );
                          const minVal = parseFloat(
                            value?.trim?.()
                          );

                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (minVal > maxVal) {
                              return "Min hash rate must be less than or equal to max hash rate";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "minimumHashRate"
                            ] = element)
                          }
                          label="Min Hash Rate"
                          style={{ flex: 1 }}
                          error={!!errors.minimumHashRate}
                          helperText={
                            errors.minimumHashRate
                              ? errors.minimumHashRate
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.maximumHashRate) {
                              trigger("minimumHashRate");
                            } else {
                              trigger([
                                "minimumHashRate",
                                "maximumHashRate",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumHashRate",
                              "maximumHashRate",
                            ]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="maximumHashRate"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            watch(
                              "minimumHashRate"
                            )?.trim?.()
                          );
                          const maxVal = parseFloat(
                            value?.trim?.()
                          );

                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (maxVal < minVal) {
                              return "Max hash rate must be greater than or equal to min hash rate";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "maximumHashRate"
                            ] = element)
                          }
                          label="Max Hash Rate"
                          style={{ flex: 1 }}
                          error={!!errors.maximumHashRate}
                          helperText={
                            errors.maximumHashRate
                              ? errors.maximumHashRate
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.minimumHashRate) {
                              trigger("maximumHashRate");
                            } else {
                              trigger([
                                "minimumHashRate",
                                "maximumHashRate",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumHashRate",
                              "maximumHashRate",
                            ]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="IPAddressContainer"
                >
                  <H8TitleMedium>IP Address</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="fromIP"
                      control={control}
                      rules={{
                        validate: (value) => {
                          if (
                            value &&
                            ipToNumberNoBit(value) === -1
                          ) {
                            return "Invalid IP address format";
                          }
                          if (
                            value &&
                            toIP &&
                            ipToNumberNoBit(value) >
                              ipToNumberNoBit(toIP)
                          ) {
                            return "From IP must be less than to IP";
                          }
                          return true;
                        },
                      }}
                      defaultValue={null}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          inputRef={(element) =>
                            (fieldRefs.current["fromIP"] =
                              element)
                          }
                          label="From"
                          style={{ flex: 1 }}
                          error={!!errors.fromIP}
                          helperText={
                            errors.fromIP
                              ? errors.fromIP.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.toIP) {
                              trigger("fromIP");
                            } else {
                              trigger(["fromIP", "toIP"]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger(["fromIP", "toIP"]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="toIP"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          if (
                            value &&
                            ipToNumberNoBit(value) === -1
                          ) {
                            return "Invalid IP address format";
                          }
                          if (
                            value &&
                            fromIP &&
                            ipToNumberNoBit(value) <
                              ipToNumberNoBit(fromIP)
                          ) {
                            return "To IP must be greater than from IP";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          label="To"
                          style={{ flex: 1 }}
                          inputRef={(element) =>
                            (fieldRefs.current["toIP"] =
                              element)
                          }
                          error={!!errors.toIP}
                          helperText={
                            errors.toIP
                              ? errors.toIP.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.fromIP) {
                              trigger("toIP");
                            } else {
                              trigger(["fromIP", "toIP"]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger(["fromIP", "toIP"]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="modelContainer"
                >
                  <H8TitleMedium>Model</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors} fullWidth>
                      {/* <InputLabel>Model</InputLabel> */}
                      <Controller
                        name="model"
                        control={control}
                        defaultValue={[]}
                        render={({
                          field: { onChange, value, ref },
                        }) => (
                          <Autocomplete
                            fullWidth
                            multiple
                            disableCloseOnSelect
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            inputValue={inputModelValue}
                            onChange={(_, data, reason) => {
                              if (
                                reason === "selectOption"
                              ) {
                                onChange(data);
                              }
                            }}
                            onInputChange={(
                              _,
                              inputValue,
                              reason
                            ) => {
                              if (reason === "input") {
                                setInputModelValue(
                                  inputValue
                                );
                              }
                            }}
                            onClose={(_, reason) => {
                              if (
                                reason === "blur" ||
                                reason === "escape"
                              ) {
                                setInputModelValue("");
                              }
                            }}
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            value={value || []}
                            clearIcon={null}
                            options={auradineModels} // Replace with your options
                            filterOptions={(
                              options,
                              { inputValue }
                            ) =>
                              options.filter(
                                (option) =>
                                  option &&
                                  option
                                    .toLowerCase()
                                    .includes(
                                      inputValue
                                        ? inputValue.toLowerCase()
                                        : ""
                                    )
                              )
                            }
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label="Model"
                                variant="outlined"
                                inputRef={ref}
                              />
                            )}
                            renderTags={() => null}
                          />
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={4}
                    maxWidth={"62.5rem"}
                    flexWrap={"wrap"}
                  >
                    {selectedModel?.map((model, index) => (
                      <PlaceHolderButton
                        key={index}
                        onClose={() =>
                          handleModelAutoCompleteDeletion(
                            model
                          )
                        }
                        text={model}
                      />
                    ))}
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="modeContainer"
                >
                  <H8TitleMedium>Mode</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors} fullWidth>
                      <Controller
                        name="mode"
                        control={control}
                        defaultValue={[]}
                        render={({
                          field: { onChange, value, ref },
                        }) => (
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={[
                              "eco",
                              "turbo",
                              "custom",
                            ]}
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            value={value || []}
                            onChange={(_, data) =>
                              onChange(data)
                            }
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label="Mode"
                                variant="outlined"
                                inputRef={ref}
                              />
                            )}
                            renderTags={() => null}
                          />
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={4}
                    maxWidth={"62.5rem"}
                    flexWrap={"wrap"}
                  >
                    {Array.isArray(modeValue) &&
                      modeValue?.map((status, index) => (
                        <PlaceHolderButton
                          key={index}
                          onClose={() =>
                            handleModeAutoCompleteDeletion(
                              status
                            )
                          }
                          text={status}
                        />
                      ))}
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="statusContainer"
                >
                  <H8TitleMedium>Status</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors} fullWidth>
                      <Controller
                        name="status"
                        control={control}
                        defaultValue={[]}
                        render={({
                          field: { onChange, value, ref },
                        }) => (
                          <Autocomplete
                            fullWidth
                            multiple
                            disableCloseOnSelect
                            options={statusOptions}
                            groupBy={(option) =>
                              option.group
                            }
                            getOptionLabel={(option) =>
                              option.label
                            }
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                " & .MuiAutocomplete-groupLabel":
                                  {
                                    backgroundColor:
                                      colors.background.accent,
                                    color: colors.text.primary,
                                  },
                                color: colors.text.primary,
                              },
                            }}
                            value={(value || [])
                              .map((label) =>
                                statusOptions.find(
                                  (option) =>
                                    option.label === label
                                )
                              )
                              .filter(Boolean)}
                            onChange={(
                              _,
                              selectedOptions
                            ) =>
                              onChange(
                                selectedOptions.map(
                                  (option) => option?.label
                                )
                              )
                            }
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label="Status"
                                variant="outlined"
                                inputRef={ref}
                              />
                            )}
                            renderTags={() => null}
                          />
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={4}
                    maxWidth={"62.5rem"}
                    flexWrap={"wrap"}
                  >
                    {selectedAutoCompleteOptions?.map(
                      (status, index) => (
                        <PlaceHolderButton
                          key={index}
                          onClose={() =>
                            handleStatusAutoCompleteDeletion(
                              status
                            )
                          }
                          text={status}
                        />
                      )
                    )}
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className
                >
                  <H8TitleMedium>Uptime (s)</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="minUpTime"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            value?.trim?.()
                          );
                          const maxVal = parseFloat(
                            watch("maxUpTime")?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (minVal > maxVal) {
                              return "Min uptime must be less than or equal to max uptime";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          label="Min Uptime"
                          style={{ flex: 1 }}
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "minUpTime"
                            ] = element)
                          }
                          error={!!errors.minUpTime}
                          helperText={
                            errors.minUpTime
                              ? errors.minUpTime.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.maxUpTime) {
                              trigger("minUpTime");
                            } else {
                              trigger([
                                "minUpTime",
                                "maxUpTime",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minUpTime",
                              "maxUpTime",
                            ]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="maxUpTime"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            watch("minUpTime")?.trim?.()
                          );
                          const maxVal = parseFloat(
                            value?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (maxVal < minVal) {
                              return "Max uptime must be greater than or equal to min uptime";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          label="Max Uptime"
                          style={{ flex: 1 }}
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "maxUpTime"
                            ] = element)
                          }
                          error={!!errors.maxUpTime}
                          helperText={
                            errors.maxUpTime
                              ? errors.maxUpTime.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.minUpTime) {
                              trigger("maxUpTime");
                            } else {
                              trigger([
                                "minUpTime",
                                "maxUpTime",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minUpTime",
                              "maxUpTime",
                            ]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className
                >
                  <H8TitleMedium>Power (W)</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="minPower"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            value?.trim?.()
                          );
                          const maxVal = parseFloat(
                            watch("maxPower")?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (minVal > maxVal) {
                              return "Min power must be less than or equal to max power";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          label="Min Power"
                          style={{ flex: 1 }}
                          inputRef={(element) =>
                            (fieldRefs.current["minPower"] =
                              element)
                          }
                          error={!!errors.minPower}
                          helperText={
                            errors.minPower
                              ? errors.minPower.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.maxPower) {
                              trigger("minPower");
                            } else {
                              trigger([
                                "minPower",
                                "maxPower",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minPower",
                              "maxPower",
                            ]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="maxPower"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            watch("minPower")?.trim?.()
                          );
                          const maxVal = parseFloat(
                            value?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (maxVal < minVal) {
                              return "Max power must be greater than or equal to min power";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          type="number"
                          label="Max Power"
                          style={{ flex: 1 }}
                          inputRef={(element) =>
                            (fieldRefs.current["maxPower"] =
                              element)
                          }
                          error={!!errors.maxPower}
                          helperText={
                            errors.maxPower
                              ? errors.maxPower.message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (!errors.minPower) {
                              trigger("maxPower");
                            } else {
                              trigger([
                                "minPower",
                                "maxPower",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minPower",
                              "maxPower",
                            ]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className
                >
                  <H8TitleMedium>
                    Power Efficiency (J/THs)
                  </H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <Controller
                      name="minimumPowerEfficiency"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            value?.trim?.()
                          );
                          const maxVal = parseFloat(
                            watch(
                              "maximumPowerEfficiency"
                            )?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (minVal > maxVal) {
                              return "Min power efficiency must be less than or equal to max power efficiency";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          label="Min Power Efficiency"
                          style={{ flex: 1 }}
                          type="number"
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "minimumPowerEfficiency"
                            ] = element)
                          }
                          error={
                            !!errors.minimumPowerEfficiency
                          }
                          helperText={
                            errors.minimumPowerEfficiency
                              ? errors
                                  .minimumPowerEfficiency
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (
                              !errors.maximumPowerEfficiency
                            ) {
                              trigger(
                                "minimumPowerEfficiency"
                              );
                            } else {
                              trigger([
                                "minimumPowerEfficiency",
                                "maximumPowerEfficiency",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumPowerEfficiency",
                              "maximumPowerEfficiency",
                            ]);
                          }}
                        />
                      )}
                    />

                    <Controller
                      name="maximumPowerEfficiency"
                      control={control}
                      defaultValue={null}
                      rules={{
                        validate: (value) => {
                          const minVal = parseFloat(
                            watch(
                              "minimumPowerEfficiency"
                            )?.trim?.()
                          );
                          const maxVal = parseFloat(
                            value?.trim?.()
                          );
                          if (
                            !Number.isNaN(minVal) &&
                            !Number.isNaN(maxVal)
                          ) {
                            if (maxVal < minVal) {
                              return "Max power efficiency must be greater than or equal to min power efficiency";
                            }
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          label="Max Power Efficiency"
                          style={{ flex: 1 }}
                          type="number"
                          inputRef={(element) =>
                            (fieldRefs.current[
                              "maximumPowerEfficiency"
                            ] = element)
                          }
                          error={
                            !!errors.maximumPowerEfficiency
                          }
                          helperText={
                            errors.maximumPowerEfficiency
                              ? errors
                                  .maximumPowerEfficiency
                                  .message
                              : ""
                          }
                          onChange={(e) => {
                            field.onChange(e);
                            if (
                              !errors.minimumPowerEfficiency
                            ) {
                              trigger(
                                "maximumPowerEfficiency"
                              );
                            } else {
                              trigger([
                                "minimumPowerEfficiency",
                                "maximumPowerEfficiency",
                              ]);
                            }
                          }}
                          onBlur={() => {
                            field.onBlur();
                            trigger([
                              "minimumPowerEfficiency",
                              "maximumPowerEfficiency",
                            ]);
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="tuningConfigurationContainer"
                >
                  <H8TitleMedium>
                    Tuning configuration
                  </H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={6}
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 5,
                      }}
                    >
                      <Controller
                        name="tuningConfiguration"
                        control={control}
                        defaultValue={null}
                        render={({
                          field: { value, onChange },
                        }) => (
                          <StyledToggleButton
                            colors={colors}
                            value={"off"}
                            onClick={() =>
                              onChange(
                                selectedTuningConfiguration ===
                                  "off"
                                  ? null
                                  : "off"
                              )
                            }
                            selected={
                              selectedTuningConfiguration ===
                              "off"
                            }
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                          >
                            {selectedTuningConfiguration ===
                            "off" ? (
                              <CheckIcon
                                fontSize={"small"}
                              />
                            ) : (
                              ""
                            )}{" "}
                              miner
                          </StyledToggleButton>
                        )}
                      />
                      <Controller
                        name="tuningConfiguration"
                        control={control}
                        defaultValue={null}
                        render={({
                          field: { value, onChange },
                        }) => (
                          <StyledToggleButton
                            colors={colors}
                            value={"on"}
                            onClick={() =>
                              onChange(
                                selectedTuningConfiguration ===
                                  "on"
                                  ? null
                                  : "on"
                              )
                            }
                            selected={
                              selectedTuningConfiguration ===
                              "on"
                            }
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                          >
                            {selectedTuningConfiguration ===
                            "on" ? (
                              <CheckIcon
                                fontSize={"small"}
                              />
                            ) : (
                              ""
                            )}
                              fluxvision
                          </StyledToggleButton>
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="tagsContainer"
                >
                  <H8TitleMedium>Select Tags</H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors} fullWidth>
                      {/*<InputLabel>Status</InputLabel>*/}
                      <Controller
                        name="tags"
                        control={control}
                        defaultValue={null}
                        render={({
                          field: { onChange, value, ref },
                        }) => (
                          <Autocomplete
                            fullWidth
                            multiple
                            disableCloseOnSelect
                            inputValue={tagsValue} // <-- make input controlled
                            onChange={(_, data, reason) => {
                              if (
                                reason === "selectOption"
                              ) {
                                onChange(data);
                              }
                            }}
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            onInputChange={(
                              _,
                              data,
                              reason
                            ) => {
                              if (reason === "input") {
                                setTagsValue(data);
                              }
                            }}
                            onClose={() =>
                              handleTagsSearch("")
                            }
                            value={value || []}
                            clearIcon={null}
                            options={
                              Array.isArray(tags) &&
                              tags.length > 0
                                ? tags
                                : []
                            } // Replace with your options
                            ListboxProps={{
                              onScroll: handleTagsScroll,
                              ref: TagsListBoxRef,
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label="Select Tags"
                                variant="outlined"
                                inputRef={ref}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {isTagsDataLoading ? (
                                        <CircularProgress
                                          size={24}
                                          sx={{ color: colors.primary.main }} 
                                        />
                                      ) : null}
                                      {
                                        params.InputProps
                                          .endAdornment
                                      }
                                    </>
                                  ),
                                }}
                              />
                            )}
                            renderTags={() => null}
                          />
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={4}
                    maxWidth={"62.5rem"}
                    flexWrap={"wrap"}
                  >
                    {selectedTags?.map((tag, index) => (
                      <PlaceHolderButton
                        key={index}
                        onClose={() =>
                          handleTagsAutoCompleteDeletion(
                            tag
                          )
                        }
                        text={tag}
                      />
                    ))}
                  </Box>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="chassisSerialNumberContainer"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <H8TitleMedium>
                      Chassis Serial Number
                    </H8TitleMedium>
                    <StyledToggleButtonGroup
                      colors={colors}
                      value={chassisMode}
                      exclusive
                      size="small"
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setChassisMode(newValue);
                          if (newValue === "saved") {
                            setValue("chassis", []);
                            setValue("chassis1", "");
                            setSerialNumbersValue("");
                          } else {
                            setValue("chassisListName", "");
                          }
                        }
                      }}
                    >
                      <StyledToggleButton
                        sx={{
                          textTransform: "none",
                          minWidth: "6rem",
                        }}
                        value="individual"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {chassisMode === "individual" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                            Individual
                        </Box>
                      </StyledToggleButton>
                      <StyledToggleButton
                        sx={{
                          textTransform: "none",  
                          minWidth: "6rem",
                        }}
                        value="saved"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {chassisMode === "saved" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                            Saved Lists
                        </Box>
                      </StyledToggleButton>
                    </StyledToggleButtonGroup>
                  </Box>
                  {chassisMode === "individual" ? ( // ... existing individual mode JSX ...
                    <>
                      <Box
                        display="flex"
                        flexDirection="row"
                        flexGrow={1}
                      >
                        <StyledFormControl colors={colors} fullWidth>
                          {/*<InputLabel>Status</InputLabel>*/}
                          <Controller
                            name="chassis"
                            control={control}
                            defaultValue={null}
                            render={({
                              field: {
                                onChange,
                                value,
                                ref,
                              },
                            }) => (
                              <Autocomplete
                                fullWidth
                                freeSolo
                                clearIcon={<CloseIcon sx={{ color: colors.text.muted }} />}
                                disableClearable
                                multiple
                                inputValue={
                                  serialNumbersValue
                                }
                                disableCloseOnSelect
                                onChange={(_, data) =>
                                  onChange(data)
                                }
                                slotProps={{
                                  popupIndicator: {
                                    sx: { color: colors.text.muted , 
                                    '&:hover': { color: colors.text.primary },
                                  }
                                  },
                                  clearIndicator: {
                                    sx: {
                                      color: colors.text.muted,
                                      '&:hover': { color: colors.text.primary },
                                    },
                                  },
                                }}
                                onInputChange={(
                                  _,
                                  data,
                                  reason
                                ) => {
                                  if (reason === "input") {
                                    setSerialNumbersValue(
                                      data
                                    );
                                    handleSerialNumbersSearch(
                                      data
                                    );
                                  }
                                }}
                                value={value || []}
                                // sx={{ maxWidth: "19rem", minWidth: "19rem" }}
                                options={
                                  Array.isArray(
                                    serialNumbers
                                  ) &&
                                  serialNumbers.length > 0
                                    ? serialNumbers
                                    : []
                                } // Replace with your options
                                ListboxProps={{
                                  onScroll:
                                    handleSerialNumbersScroll,
                                  ref: SerialNumbersListBoxRef,
                                  sx: {
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    backgroundColor:
                                      colors.background.paper,
                                    "&.selected": {
                                      backgroundColor:
                                        colors.primary.light,
                                    },
                                    color: colors.text.primary,
                                  },
                                }}
                                renderInput={(params) => (
                                  <StyledTextField colors={colors}
                                    {...params}
                                    label="Chassis Serial Number"
                                    variant="outlined"
                                    inputRef={ref}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {isSerialNumbersLoading ? (
                                            <CircularProgress
                                              size={24}
                                              sx={{ color: colors.primary.main }} 
                                            />
                                          ) : null}
                                          {serialNumbersValue && (
                                            <IconButton
                                              onClick={() => {
                                                setSerialNumbersValue(
                                                  ""
                                                );
                                                handleSerialNumbersSearch(
                                                  ""
                                                );
                                              }}
                                              size="small"
                                              edge="end"
                                            >
                                              <CloseIcon fontSize="small" sx={{ color: colors.text.muted }} />
                                            </IconButton>
                                          )}
                                          {
                                            params
                                              .InputProps
                                              .endAdornment
                                          }
                                        </>
                                      ),
                                    }}
                                  />
                                )}
                                renderTags={() => null}
                              />
                            )}
                          />
                        </StyledFormControl>
                      </Box>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        gap={4}
                        maxWidth={"62.5rem"}
                        flexWrap={"wrap"}
                      >
                        {selectedChassisSerialNumber?.map(
                          (chassis, index) => (
                            <PlaceHolderButton
                              key={index}
                              onClose={() =>
                                handleChassisSerialNumberAutoCompleteDeletion(
                                  chassis
                                )
                              }
                              text={chassis}
                            />
                          )
                        )}
                      </Box>
                    </>
                  ) : (
                    <StyledFormControl colors={colors} fullWidth>
                      <Controller
                        name="chassisListName"
                        control={control}
                        defaultValue=""
                        render={({
                          field: { onChange, value },
                        }) => (
                          <Autocomplete
                            fullWidth
                            value={value || null}
                            onChange={(event, newValue) => {
                              onChange(newValue || "");
                            }}
                            options={chassisListNames}
                            disabled={
                              chassisListNames.length === 0
                            }
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label={
                                  chassisListNames.length ===
                                  0
                                    ? "No saved lists"
                                    : "Select Saved Lists"
                                }
                                variant="outlined"
                              />
                            )}
                          />
                        )}
                      />
                    </StyledFormControl>
                  )}
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="controlBoardContainer"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <H8TitleMedium>
                      Control Board Serial Number
                    </H8TitleMedium>
                    <StyledToggleButtonGroup
                      colors={colors}
                      value={cbsnMode}
                      exclusive
                      size="small"
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setCbsnMode(newValue);
                          if (newValue === "saved") {
                            setValue("CBSN", []);
                            setValue("CBSN1", "");
                            setCbsnInputValue("");
                          } else {
                            setValue("CBSNListName", "");
                          }
                        }
                      }}
                    >
                      <StyledToggleButton
                        sx={{
                            textTransform: "none",
                          minWidth: "6rem",
                        }}
                        value="individual"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {cbsnMode === "individual" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                            Individual
                        </Box>
                      </StyledToggleButton>
                      <StyledToggleButton
                        sx={{
                          textTransform: "none",
                          minWidth: "6rem",
                        }}
                        value="saved"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {cbsnMode === "saved" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                            Saved Lists
                        </Box>
                      </StyledToggleButton>
                    </StyledToggleButtonGroup>
                  </Box>
                  {cbsnMode === "individual" ? ( // ... existing individual mode JSX ...
                    <>
                      <Box
                        display="flex"
                        flexDirection="row"
                        flexGrow={1}
                      >
                        <StyledFormControl colors={colors} fullWidth>
                          <Controller
                            name="CBSN"
                            control={control}
                            defaultValue={null}
                            render={({
                              field: {
                                onChange,
                                value,
                                ref,
                              },
                            }) => (
                              <Autocomplete
                                fullWidth
                                freeSolo
                                disableClearable
                                multiple
                                disableCloseOnSelect
                                value={value || []}
                                inputValue={cbsnInputValue} // <-- make input controlled
                                onInputChange={(
                                  _,
                                  newInputValue,
                                  reason
                                ) => {
                                  if (reason === "input") {
                                    setCbsnInputValue(
                                      newInputValue
                                    );
                                    handleCBSNSearch(
                                      newInputValue
                                    );
                                  }
                                }}
                                onChange={(_, data) => {
                                  onChange(data);
                                }}
                                options={
                                  Array.isArray(CBSNs) &&
                                  CBSNs.length > 0
                                    ? CBSNs
                                    : []
                                }
                                clearIcon={<CloseIcon sx={{ color: colors.text.muted }} />}
                                slotProps={{
                                  popupIndicator: {
                                    sx: { color: colors.text.muted , 
                                    '&:hover': { color: colors.text.primary },
                                  }
                                  },
                                  clearIndicator: {
                                    sx: {
                                      color: colors.text.muted,
                                      '&:hover': { color: colors.text.primary },
                                    },
                                  },
                                }}
                                ListboxProps={{
                                  onScroll:
                                    handleCBSNScroll,
                                  ref: CBSNListBoxRef,
                                  sx: {
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    backgroundColor:
                                      colors.background.paper,
                                    "&.selected": {
                                      backgroundColor:
                                        colors.primary.light,
                                    },
                                    color: colors.text.primary,
                                  },
                                }}
                                renderInput={(params) => (
                                  <StyledTextField colors={colors}
                                    {...params}
                                    label="Control Board Serial Number"
                                    variant="outlined"
                                    inputRef={ref}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {isCBSNLoading && (
                                            <CircularProgress
                                              size={24}
                                              sx={{ color: colors.primary.main }} 
                                            />
                                          )}
                                          {cbsnInputValue && (
                                            <IconButton
                                              onClick={() => {
                                                setCbsnInputValue(
                                                  ""
                                                );
                                                handleCBSNSearch(
                                                  ""
                                                );
                                              }}
                                              size="small"
                                              edge="end"
                                            >
                                              <CloseIcon fontSize="small" sx={{ color: colors.text.muted }} />
                                            </IconButton>
                                          )}
                                          {
                                            params
                                              .InputProps
                                              .endAdornment
                                          }
                                        </>
                                      ),
                                    }}
                                  />
                                )}
                                renderTags={() => null}
                              />
                            )}
                          />
                        </StyledFormControl>
                      </Box>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        gap={4}
                        maxWidth={"62.5rem"}
                        flexWrap={"wrap"}
                      >
                        {selectedControlBoardSerialNumber?.map(
                          (CBSN, index) => (
                            <PlaceHolderButton
                              key={index}
                              onClose={() =>
                                handleControlBoardSerialNumberAutoCompleteDeletion(
                                  CBSN
                                )
                              }
                              text={CBSN}
                            />
                          )
                        )}
                      </Box>
                    </>
                  ) : (
                    <StyledFormControl colors={colors} fullWidth>
                      <Controller
                        name="CBSNListName"
                        control={control}
                        defaultValue=""
                        render={({
                          field: { onChange, value },
                        }) => (
                          <Autocomplete
                            fullWidth
                            value={value || null}
                            onChange={(event, newValue) => {
                              onChange(newValue || "");
                            }}
                            options={cbsnListNames}
                            disabled={
                              cbsnListNames.length === 0
                            }
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label={
                                  cbsnListNames.length === 0
                                    ? "No saved lists"
                                    : "Select Saved Lists"
                                }
                                variant="outlined"
                              />
                            )}
                          />
                        )}
                      />
                    </StyledFormControl>
                  )}
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="macAddressContainer"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <H8TitleMedium>
                      Mac Address
                    </H8TitleMedium>
                    <StyledToggleButtonGroup
                      colors={colors}
                      value={macMode}
                      exclusive
                      size="small"
                      onChange={(e, newValue) => {
                        if (newValue) {
                          setMacMode(newValue);
                          if (newValue === "saved") {
                            setValue("mac", []);
                            setValue("mac1", "");
                            setMacsValue("");
                          } else {
                            setValue("macListName", "");
                          }
                        }
                      }}
                    >
                      <StyledToggleButton
                        sx={{
                          textTransform: "none",
                          minWidth: "6rem",
                        }}
                        value="individual"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {macMode === "individual" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                          Individual
                        </Box>
                      </StyledToggleButton>
                      <StyledToggleButton
                        sx={{
                          textTransform: "none",
                          minWidth: "6rem",
                        }}
                        value="saved"
                        colors={colors}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            justifyContent: "center",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          {macMode === "saved" && (
                            <CheckIcon
                              sx={{
                                marginBottom: "3%",
                              }}
                              fontSize="small"
                            />
                          )}
                          Saved Lists
                        </Box>
                      </StyledToggleButton>
                    </StyledToggleButtonGroup>
                  </Box>
                  {macMode === "individual" ? ( // ... existing individual mode JSX ...
                    <>
                      <Box
                        display="flex"
                        flexDirection="row"
                        flexGrow={1}
                      >
                        <StyledFormControl colors={colors} fullWidth>
                          {/*<InputLabel>Status</InputLabel>*/}
                          <Controller
                            name="mac"
                            control={control}
                            defaultValue={null}
                            render={({
                              field: {
                                onChange,
                                value,
                                ref,
                              },
                            }) => (
                              <Autocomplete
                                fullWidth
                                multiple
                                disableClearable
                                inputValue={macsValue}
                                disableCloseOnSelect
                                onChange={(_, data) =>
                                  onChange(data)
                                }
                                slotProps={{
                                  popupIndicator: {
                                    sx: { color: colors.text.muted , 
                                    '&:hover': { color: colors.text.primary },
                                  }
                                  },
                                  clearIndicator: {
                                    sx: {
                                      color: colors.text.muted,
                                      '&:hover': { color: colors.text.primary },
                                    },
                                  },
                                }}
                                onInputChange={(
                                  _,
                                  data,
                                  reason
                                ) => {
                                  if (reason === "input") {
                                    setMacsValue(data);
                                    handleMacsSearch(data);
                                  }
                                }}
                                value={value || []}
                                clearIcon={null}
                                // sx={{ maxWidth: "19rem", minWidth: "19rem" }}
                                options={
                                  Array.isArray(mac) &&
                                  mac.length > 0
                                    ? mac
                                    : []
                                } // Replace with your options
                                ListboxProps={{
                                  onScroll:
                                    handleMacsScroll,
                                  ref: MacsListBoxRef,
                                  sx: {
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    backgroundColor:
                                      colors.background.paper,
                                    "&.selected": {
                                      backgroundColor:
                                        colors.primary.light,
                                    },
                                    color: colors.text.primary,
                                  },
                                }}
                                renderInput={(params) => (
                                  <StyledTextField colors={colors}
                                    {...params}
                                    label="Mac Address"
                                    variant="outlined"
                                    inputRef={ref}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {isMacsLoading ? (
                                            <CircularProgress
                                              size={24}
                                              sx={{ color: colors.primary.main }} 
                                            />
                                          ) : null}
                                          {macsValue && (
                                            <IconButton
                                              onClick={() => {
                                                setMacsValue(
                                                  ""
                                                );
                                                handleMacsSearch(
                                                  ""
                                                );
                                              }}
                                              size="small"
                                              edge="end"
                                            >
                                              <CloseIcon fontSize="small" sx={{ color: colors.text.muted }} />
                                            </IconButton>
                                          )}
                                          {
                                            params
                                              .InputProps
                                              .endAdornment
                                          }
                                        </>
                                      ),
                                    }}
                                  />
                                )}
                                renderTags={() => null}
                              />
                            )}
                          />
                        </StyledFormControl>
                      </Box>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        gap={4}
                        maxWidth={"62.5rem"}
                        flexWrap={"wrap"}
                      >
                        {selectedMacs?.map((Mac, index) => (
                          <PlaceHolderButton
                            key={index}
                            onClose={() =>
                              handleMacsAutoCompleteDeletion(
                                Mac
                              )
                            }
                            text={Mac}
                          />
                        ))}
                      </Box>
                    </>
                  ) : (
                    <StyledFormControl colors={colors} fullWidth>
                      <Controller
                        name="macListName"
                        control={control}
                        defaultValue=""
                        render={({
                          field: { onChange, value },
                        }) => (
                          <Autocomplete
                            fullWidth
                            value={value || null}
                            onChange={(event, newValue) => {
                              onChange(newValue || "");
                            }}
                            options={macListNames}
                            disabled={
                              macListNames.length === 0
                            }
                            ListboxProps={{
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                                color: colors.text.primary,
                              },
                            }}
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label={
                                  macListNames.length === 0
                                    ? "No saved lists"
                                    : "Select Saved Lists"
                                }
                                variant="outlined"
                              />
                            )}
                          />
                        )}
                      />
                    </StyledFormControl>
                  )}
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={4}
                  className="versionContainer"
                >
                  <H8TitleMedium>
                    Software Version
                  </H8TitleMedium>
                  <Box
                    display="flex"
                    flexDirection="row"
                    flexGrow={1}
                  >
                    <StyledFormControl colors={colors} fullWidth>
                      {/*<InputLabel>Status</InputLabel>*/}
                      <Controller
                        name="version"
                        control={control}
                        defaultValue={null}
                        render={({
                          field: { onChange, value, ref },
                        }) => (
                          <Autocomplete
                            fullWidth
                            multiple
                            inputValue={versionValue} // <-- make input controlled
                            disableCloseOnSelect
                            onChange={(_, data) =>
                              onChange(data)
                            }
                            slotProps={{
                              popupIndicator: {
                                sx: { color: colors.text.muted , 
                                '&:hover': { color: colors.text.primary },
                              }
                              },
                              clearIndicator: {
                                sx: {
                                  color: colors.text.muted,
                                  '&:hover': { color: colors.text.primary },
                                },
                              },
                            }}
                            onInputChange={(
                              _,
                              data,
                              reason
                            ) => {
                              if (reason === "input") {
                                handleSoftwareVersionsSearch(
                                  data
                                );
                              }
                            }}
                            value={value || []}
                            onClose={(_, reason) => {
                              if (
                                reason === "blur" ||
                                reason === "escape"
                              ) {
                                handleSoftwareVersionsSearch(
                                  ""
                                );
                              }
                            }}
                            clearIcon={null}
                            // sx={{ maxWidth: "19rem", minWidth: "19rem" }}
                            options={
                              Array.isArray(
                                softwareVersions
                              ) &&
                              softwareVersions.length > 0
                                ? softwareVersions
                                : []
                            } // Replace with your options
                            ListboxProps={{
                              onScroll:
                                handleSoftwareVersionsScroll,
                              ref: SoftwareVersionsListBoxRef,
                              sx: {
                                maxHeight: "250px",
                                overflowY: "auto",
                                backgroundColor: colors.background.paper,
                                color: colors.text.primary,
                                "&.selected": {
                                  backgroundColor:
                                    colors.primary.light,
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <StyledTextField colors={colors}
                                {...params}
                                label="Software Version"
                                variant="outlined"
                                inputRef={ref}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {isSoftwareVersionsLoading ? (
                                        <CircularProgress
                                          size={24}
                                          sx={{ color: colors.primary.main }} 
                                        />
                                      ) : null}
                                      {
                                        params.InputProps
                                          .endAdornment
                                      }
                                    </>
                                  ),
                                }}
                              />
                            )}
                            renderTags={() => null}
                          />
                        )}
                      />
                    </StyledFormControl>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={4}
                    maxWidth={"62.5rem"}
                    flexWrap={"wrap"}
                  >
                    {selectedSoftwareVersion?.map(
                      (softwareVersion, index) => (
                        <PlaceHolderButton
                          key={index}
                          onClose={() =>
                            handleSoftwareVersionAutoCompleteDeletion(
                              softwareVersion
                            )
                          }
                          text={softwareVersion}
                        />
                      )
                    )}
                  </Box>
                </Box>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                gap={4}
                justifyContent={"flex-end"}
                paddingTop={4}
              >
                <SecondaryButton colors={colors} onClick={ClearFilters}>
                  Clear
                </SecondaryButton>
                <PrimaryButton colors={colors} type="submit">
                  Apply
                </PrimaryButton>
              </Box>
            </form>
          </Box>
        )}
        {selectedTab === 1 && (
          <SavedLists
            tabIndex={selectedTab}
            filterNames={filterNames}
            refetchFilterNames={refetchFilterNames}
            areFilterNamesLoading={areFilterNamesLoading}
            getValue={getValues}
            setFilterValue={setValue}
          />
        )}
      </DialogContent>
    </StyledDialog>
  );
};

const MinerFilters = (props) => {
  const { siteListStatus } = props;
  const [openFilterModal, setOpenFilter] = useState(false);
  const { groupFilters } = useMinerPageContext();
  const { colors, currentTheme } = useTheme();

  const badgeContent = Object.entries(groupFilters).filter(
    ([key, value]) =>
      !(
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      )
  ).length;

  return (
    <>
      <Tooltip title="Filters">
        <span>
          <CustomBadge badgeContent={badgeContent} colors={colors}>
            <StyledIconButton
              colors={colors}
              open={openFilterModal}
              disabled={siteListStatus !== "ok"}
              sx={{}}
              onClick={() => setOpenFilter(true)}
            >
              <FilterList
                size="small"
                sx={{
                  color:
                    siteListStatus !== "ok"
                      ? colors.text.disabled
                      : colors.text.muted,
                }}
              />
            </StyledIconButton>
          </CustomBadge>
        </span>
      </Tooltip>
      <FilterModal
        open={openFilterModal}
        setOpenFilter={setOpenFilter}
      />
    </>
  );
};

export default MinerFilters;
